import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AccessDeniedComponent } from './access-denied.component';

@NgModule({
   declarations: [AccessDeniedComponent],
   imports: [CommonModule, MatIconModule],
})
export class AccessDeniedModule {}
